<!-- 角色菜单管理 -->
<template>
  <scroll-right-frame>
    <div class="role-menu-manage" style="padding: 0 10px 10px 10px;">
      <div style="margin: 8px;height: 36px; line-height: 36px;">
        <el-select
          size="small"
          v-model="selectWebSite"
          placeholder="请选择站点"
          @change="onSelectSiteChange"
        >
          <el-option
            v-for="webSite in webSites"
            :key="webSite.id"
            :label="webSite.name"
            :value="webSite.id">
          </el-option>
        </el-select>

        <el-select
          v-if="selectWebSite"
          size="small"
          v-model="selectRole"
          placeholder="请选择角色"
          @change="onSelectRoleChange"
          style="margin-left: 10px;"
        >
          <el-option
            v-for="role in roles"
            :key="role.id"
            :label="role.name"
            :value="role.id">
          </el-option>
        </el-select>

        <el-button
          v-if="selectWebSite && selectRole"
          size="small"
          @click="saveRoleMenuConfig"
          style="margin-left: 10px;"
        >保存</el-button>
        <el-button
          v-if="selectWebSite && selectRole"
          size="small"
          @click="handleReloadTree"
        >重新加载菜单树</el-button>
      </div>

      <div style="border: 1px solid #dcdfe6;">
        <el-tree
          v-if="selectWebSite && selectRole"
          ref="myTree"
          :data="treeData"
          :props="defaultProps"
          :empty-text="message"
          show-checkbox
          node-key="id"
          :expand-on-click-node="false"
          :default-expanded-keys="['root']"
          :check-strictly="true"
          @check="onTreeCheck"
        >
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }">
          <span class="tree-node-label">{{ node.label }}</span>
            <!--集成菜单-->
          <div class="integrated-menu-box">
              <el-checkbox-group v-model="gridMenuIds">
                <el-checkbox v-for="sMenu in data.integratedMenuList" :key="sMenu.gridMenuId" :label="sMenu.gridMenuId">{{ sMenu.gridMenuName }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <!--自定义菜单-->
          <div class="custom-menu-box">
              <el-checkbox-group v-model="gridMenuIds">
                <el-checkbox v-for="sMenu in data.customMenuList" :key="sMenu.gridMenuId" :label="sMenu.gridMenuId">{{ sMenu.gridMenuName }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </span>
        </el-tree>
      </div>
      <div v-if="!selectWebSite || !selectRole" class="empty-choose">
        <img src="static/styles/images/choose.png">
        <br>
        <span class="empty-text">{{ message }}</span>
      </div>
    </div>
  </scroll-right-frame>
</template>

<script>
  import util from '../../libs/util'
  import ScrollRightFrame from '../../components/scroll-right-frame.vue'

  export default {
    components: {
      ScrollRightFrame
    },
    name: 'role_menu_manage',
    data() {
      return {
        selectWebSite: '',
        webSites: [],
        loading: false,
        selectRole: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        roles: [],
        gridMenuIds: []
      }
    },
    computed: {
      message: function () {
        if (!this.selectWebSite) {
          return '请选择站点'
        } else if (!this.selectRole) {
          return '请选择角色'
        } else {
          return ''
        }
      }
    },
    created() {
      this.loadWebSites()
    },
    methods: {
      loadWebSites() { // 加载webSite
        util.ajax.post('/superAdmin/permissionManage/getAllWebSites').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.webSites = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取站点数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取站点数据失败：'})
          console.error(err)
        })
      },
      onSelectSiteChange() { // 选择站点后加载站点的菜单数据
        this.selectRole = ''
        this.loadRoles()
      },
      loadRoles() { // 加载角色列表
        let params = {webSiteId: this.selectWebSite}
        util.ajax.post('/superAdmin/permissionManage/getAllRoles', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.roles = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取角色数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取角色数据失败：'})
          console.error(err)
        })
      },
      onSelectRoleChange() { // 选择角色后加载角色的菜单树
        this.loadTreeData()
      },
      loadTreeData() { // 加载角色菜单树
        let params = {webSiteId: this.selectWebSite, roleId: this.selectRole}
        util.ajax.post('/superAdmin/permissionManage/menu/treeWithSubMenu', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.treeData = [{
              id: 'root',
              name: '功能列表',
              children: res.data.data,
              isLeaf: '0'
            }]
            this.loadRoleMenusAndGridMenus()
          } else {
            this.$notify.info({title: '提示', message: '获取菜单数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取菜单数据失败：'})
          console.error(err)
        })
      },
      loadRoleMenusAndGridMenus() {
        let params = {webSiteId: this.selectWebSite, roleId: this.selectRole}
        util.ajax.post('/superAdmin/permissionManage/getRoleMenuIds', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$refs.myTree.setCheckedKeys(res.data.data)
          } else {
            this.$notify.info({title: '提示', message: '获取数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取数据失败'})
          console.error(err)
        })
        util.ajax.post('/superAdmin/permissionManage/getRoleGridMenuIds', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.gridMenuIds = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取数据失败'})
          console.error(err)
        })
      },
      saveRoleMenuConfig() { // 保存角色菜单配置
        if (!this.selectRole) {
          this.$notify.info({title: '提示', message: '请选择角色'})
        }
        let menuIds = this.$refs.myTree.getCheckedKeys()
        // 删除虚拟的根节点
        for (let i = menuIds.length - 1; i >= 0; i--) {
          if (menuIds[i] === 'root') {
            menuIds.splice(i, 1)
          }
        }
        let params = {webSiteId: this.selectWebSite, roleId: this.selectRole, menuIds: menuIds, gridMenuIds: this.gridMenuIds}
        util.ajax.post('/superAdmin/permissionManage/saveRoleMenuIds', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功'})
          } else {
            this.$notify.info({title: '提示', message: '保存失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '错误：'})
          console.error(err)
        })
      },
      onTreeCheck(data) { // 节点的checkbox点击时触发
        let checked = this.nodeIsChecked(data)
        this.setChecked(data, checked, true)
      },
      nodeIsChecked(data) { // 判断节点是否选中
        return this.$refs.myTree.getCheckedKeys().includes(data.id)
      },
      setChecked(data, checked, deep) { // 设置节点的选中状态，级联gridMenu
        this.$refs.myTree.setChecked(data.id, checked)
        this.checkTreeNodeMenu(data, checked)
        if (deep) { // 是否设置子节点
          let children = data.children
          if (children && children.length > 0) {
            for (let i = 0; i < children.length; i++) {
              this.setChecked(children[i], checked, true)
            }
          }
        }
      },
      checkTreeNodeMenu(data, checked) { // 节点选中状态变化时触发
        // 级联grid菜单
        this.checkGridMenu(data.integratedMenuList, checked)
        this.checkGridMenu(data.customMenuList, checked)
      },
      checkGridMenu(menuList, checked) {
        if (menuList && menuList.length > 0) {
          let menuIds = []
          for (let i = 0; i < menuList.length; i++) {
            menuIds.push(menuList[i].gridMenuId)
          }
          if (checked) {
            util.pushAll(this.gridMenuIds, menuIds, true)
          } else {
            util.removeAll(this.gridMenuIds, menuIds)
          }
        }
      },
      handleReloadTree() {
        this.loadTreeData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/menu-manage/role_menu_manage.vue